import { LocaleContext } from 'components/MainComponent/MainComponent'
import { useContext } from 'react'
import styled from 'styled-components'

export const Aufnahmefaktoren = ({
  colorMode,
}: {
  colorMode: 'dark' | 'light' | undefined
}) => {
  const TEXT = useContext(LocaleContext)
  const { aufnahme } = TEXT
  return (
    <AufnahmefaktorenRoot>
      <Title> {aufnahme[0]}</Title>
      <Faktor>
        <img
          src={require('../../assets/icons_hot' +
            (colorMode === 'dark' ? '_dm' : '') +
            '.png')}
        />
        <div>{aufnahme[1]}</div>
      </Faktor>
      <Faktor>
        <img
          src={require('../../assets/icons_bubbles' +
            (colorMode === 'dark' ? '_dm' : '') +
            '.png')}
        />
        <div>{aufnahme[2]}</div>
      </Faktor>
      <Faktor>
        <img
          src={require('../../assets/icons_sugar' +
            (colorMode === 'dark' ? '_dm' : '') +
            '.png')}
        />
        <div>{aufnahme[3]}</div>
      </Faktor>
      <Faktor>
        <img
          src={require('../../assets/icons_fast' +
            (colorMode === 'dark' ? '_dm' : '') +
            '.png')}
        />
        <div>{aufnahme[4]}</div>
      </Faktor>
      <Faktor>
        <img
          src={require('../../assets/icons_stomach' +
            (colorMode === 'dark' ? '_dm' : '') +
            '.png')}
        />
        <div>{aufnahme[5]}</div>
      </Faktor>
      <Faktor>
        <img
          src={require('../../assets/icons_indi' +
            (colorMode === 'dark' ? '_dm' : '') +
            '.png')}
        />
        <div>{aufnahme[6]}</div>
      </Faktor>
    </AufnahmefaktorenRoot>
  )
}
const Title = styled.div`
  font-weight: 700;
  flex: 0 0 100%;
`

const AufnahmefaktorenRoot = styled.div`
  font-family: var(--font-sans-serif);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 60px;
`
const Faktor = styled.div`
  flex: 0 0 calc(48%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 15px;
  line-height: 1.3em;
  margin-bottom: 30px;
  img {
    max-width: 100px;
  }
  * {
    text-align: center;
    flex: 0 0 100%;
  }
`
